module.exports = __webpack_public_path__ + "img/icons BFr_30.728f84f6.svg";